// Add [data-notab] to any html element you don't want to be tabbable
import Dom from '../utility/dom';

const Modal = {
    open: function(target){
        for (let element of Dom.focusable) {
            element.setAttribute('tabindex', '-1');
            if(!element.hasAttribute('data-notab') && element.closest('.modal') == target){
                element.setAttribute('tabindex', '1');
            }
        }
    },
    close: function(target){
        for (let element of Dom.focusable) {
            if(element.hasAttribute('data-notab') || element.closest('.modal') == target){
                element.setAttribute('tabindex', '-1');
            }
            else {
                element.setAttribute('tabindex', '1');
            }
        }
    }
}


export default Modal;
